import React from 'react'
import TuneOutlinedIcon from '@material-ui/icons/TuneOutlined';
import VideoRow from "./VideoRow"
import "./SearchPage.css"
import ChannelRow from "./ChannelRow"

function SearchPage() {
    return (
        <div className="searchPage">
           
            <div className="searchPage__filter">
<TuneOutlinedIcon/>
<h2>FILTER</h2>
            </div>
            <hr/>

<ChannelRow 
image="https://pbs.twimg.com/profile_images/1009410305611296768/EXp41iuJ.jpg"
channel="SaiTeja Gatadi"
verified
subs="659K"
noOfVideos={382}
description="You can find some awesome videos here..."
/>
<hr/>
<VideoRow
views="1.5M"
subs="659K"
description="Learn React in this Course  "
timestamp="59 minutes ago"
channel="saitejagatadi72"
title="Lets Build a Youtube App"
image="https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcRaRd7ymrF9STpUDnhrPLQV318Jdlie0haWnw&usqp=CAU"
/>

<VideoRow
views="1.5M"
subs="659K"
description="Learn React in this Course  "
timestamp="59 minutes ago"
channel="saitejagatadi72"
title="Lets Build a Youtube App"
image="https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcRaRd7ymrF9STpUDnhrPLQV318Jdlie0haWnw&usqp=CAU"
/>

<VideoRow
views="1.5M"
subs="659K"
description="Learn React in this Course  "
timestamp="59 minutes ago"
channel="saitejagatadi72"
title="Lets Build a Youtube App"
image="https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcRaRd7ymrF9STpUDnhrPLQV318Jdlie0haWnw&usqp=CAU"
/>

<VideoRow
views="1.5M"
subs="659K"
description="Learn React in this Course  "
timestamp="59 minutes ago"
channel="saitejagatadi72"
title="Lets Build a Youtube App"
image="https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcRaRd7ymrF9STpUDnhrPLQV318Jdlie0haWnw&usqp=CAU"
/>

<VideoRow
views="1.5M"
subs="659K"
description="Learn React in this Course  "
timestamp="59 minutes ago"
channel="saitejagatadi72"
title="Lets Build a Youtube App"
image="https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcRaRd7ymrF9STpUDnhrPLQV318Jdlie0haWnw&usqp=CAU"
/>

<VideoRow
views="1.5M"
subs="659K"
description="Learn React in this Course  "
timestamp="59 minutes ago"
channel="saitejagatadi72"
title="Lets Build a Youtube App"
image="https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcRaRd7ymrF9STpUDnhrPLQV318Jdlie0haWnw&usqp=CAU"
/>


<VideoRow
views="1.5M"
subs="659K"
description="Learn React in this Course  "
timestamp="59 minutes ago"
channel="saitejagatadi72"
title="Lets Build a Youtube App"
image="https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcRaRd7ymrF9STpUDnhrPLQV318Jdlie0haWnw&usqp=CAU"
/>


<VideoRow
views="1.5M"
subs="659K"
description="Learn React in this Course  "
timestamp="59 minutes ago"
channel="saitejagatadi72"
title="Lets Build a Youtube App"
image="https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcRaRd7ymrF9STpUDnhrPLQV318Jdlie0haWnw&usqp=CAU"
/>



<VideoRow
views="1.5M"
subs="659K"
description="Learn React in this Course  "
timestamp="59 minutes ago"
channel="saitejagatadi72"
title="Lets Build a Youtube App"
image="https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcRaRd7ymrF9STpUDnhrPLQV318Jdlie0haWnw&usqp=CAU"
/>

<VideoRow
views="1.5M"
subs="659K"
description="Learn React in this Course  "
timestamp="59 minutes ago"
channel="saitejagatadi72"
title="Lets Build a Youtube App"
image="https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcRaRd7ymrF9STpUDnhrPLQV318Jdlie0haWnw&usqp=CAU"
/>

<VideoRow
views="1.5M"
subs="659K"
description="Learn React in this Course  "
timestamp="59 minutes ago"
channel="saitejagatadi72"
title="Lets Build a Youtube App"
image="https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcRaRd7ymrF9STpUDnhrPLQV318Jdlie0haWnw&usqp=CAU"
/>

<VideoRow
views="1.5M"
subs="659K"
description="Learn React in this Course  "
timestamp="59 minutes ago"
channel="saitejagatadi72"
title="Lets Build a Youtube App"
image="https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcRaRd7ymrF9STpUDnhrPLQV318Jdlie0haWnw&usqp=CAU"
/>


<VideoRow
views="1.5M"
subs="659K"
description="Learn React in this Course  "
timestamp="59 minutes ago"
channel="saitejagatadi72"
title="Lets Build a Youtube App"
image="https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcRaRd7ymrF9STpUDnhrPLQV318Jdlie0haWnw&usqp=CAU"
/>

<VideoRow
views="1.5M"
subs="659K"
description="Learn React in this Course  "
timestamp="59 minutes ago"
channel="saitejagatadi72"
title="Lets Build a Youtube App"
image="https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcRaRd7ymrF9STpUDnhrPLQV318Jdlie0haWnw&usqp=CAU"
/>
        </div>
    )
}

export default SearchPage
